import {injectable} from 'inversify';

import type {ChoiceQuestionModel} from '../../Question/ChoiceQuestion/ChoiceQuestion.model';
import type {AnswerModelProps} from '../Answer.model';

import {CheckboxesAnswerModel} from './CheckboxesAnswer.model';

@injectable()
export class CheckboxesAnswerFactory {
  create(props: AnswerModelProps<string[], ChoiceQuestionModel>) {
    return new CheckboxesAnswerModel(props);
  }
}
